export const zh = {
    dc: {
        dcNo: 'DC编号',
        dcName: 'DC名称',
        dcStatus: 'DC状态',
        dcInfo: 'DC主数据信息',
        inputDcNo: '请输入DC编号',
        inputDcName: '请输入DC名称',
        inputStatus: '请选择DC状态',
    },
    supplier: {
        supplierCode: '供应商编号',
        supplierName: '供应商名称',
        supplierCity: '供应商所在城市',
        supplierAddress: '供应商所在地址',
        supplierCountry: '供应商所在国家',
        supplierProvince: '供应商所在省份',
        supplierPostCode: '供应商邮编',
        supplierTelephoneNo: '供应商电话号码',
        supplierEmailAddress: '供应商电子邮箱',
        supplierCodeInput: '请输入供应商编号',
        supplierNameInput: '请输入供应商名称',
        supplierCityInput: '请输入供应商所在城市',
        supplierSelect: '请选择需要禁用的供应商',
        editGroup: '编辑供应商分组',
        group: '供应商分组',
        groupCode: '分组编号',
        groupName: '分组名称',
        supplier: '供应商',
        addGroup: '添加分组',
        addSupplier: '添加供应商',
        pleaseSelectGroup: '请选择分组'
    },
    carriers: {
        carriersCode: '承运商编号',
        carriersName: '承运商名称',
        carriersCity: '承运商所在城市',
        carriersAddress: '承运商所在地址',
        carriersCountry: '承运商所在国家',
        carriersProvince: '承运商所在省份',
        carriersPostCode: '承运商邮编地址',
        carriersTelephoneNo: '承运商电话号码',
        carriersEmailAddress: '承运商电子邮箱',
        carriersCodeInput: '请输入承运商编号',
        carriersNameInput: '请输入承运商名称',
        carriersCityInput: '请输入承运商所在城市',
        carriersSelect: '请选择需要禁用的承运商'
    },
    common: {
        emailAddress: '邮箱',
        status: '状态',
        statusAll: '全部',
        statusAble: '启用',
        statusDisable: '禁用',
        updateBy: '修改人',
        updateDate: '修改时间',
        dcInfo: 'DC主数据信息',
        inputDcNo: '请输入DC编号',
        inputDcName: '请输入DC名称',
        inputStatus: '请选择DC状态'
    },
    pp: {
        pickupPoint: '提货点',
        pickupPointInfo: '提货点信息',
        inputPickupPoint: '请输入提货点',
        inputStatus: '请选择状态',
        selectPickupPoint: '请选择需要删除的提货点',
    },
    plant: {
        plantNo: '工厂编号',
        plantName: '工厂名称',
        supplierNo: '供应商编号',
        supplierName: '供应商名称',
        userManage: '人员管理',
        categoryLevel1Name: 'Category Level1 Name',
        categoryLevel2Name: 'Category Level2 Name'
    },
    fiveBitCode: {
        title: '产品编码',
        name: '产品名称'
    },
    eightBitCode: {
        eightBitCode: '八位码',
        eightBitCodeName: '八位码名称'
    },
    linePrice: {
        pickupPoint: '发货市',
        lineType:"线路类型",
        dc: '到货仓库',
        temperature: '温区',
        transportaionMethod: '运输方式',
        supplierCode: '供应商编号',
        unit: '结算单位',
        effectiveBeginDate: '有效开始日期',
        price: '报价(不含税)',
        currencyCode: '币种',
        to: '到',
        supplier: '供应商',
        confirmDate: '报价确认日期',
        operation: '操作',
        update: '线路变更',
        history: '查看历史',
        sourcingNo: '报价确认单据编号',
        export: '导出',
        exportName: '线路主数据',
        fileDownloadError: '文件下载失败',
        selUpdataData: '请选择需要变更的数据'
    },
    productFreight: {
        updateDate: "报价确认时间",
        ensureToDisable: "确认所选物料运费？",
        productPrice: "产品运费（不含税）",
        futureProductPrice: "未来产品运费（不含税）",
        sendToMDM: "推送MDM",
        sureDisable: "确认要禁用所选物料运费？",
        sureEnable: "确认要启用所选物料运费？",
    },
    material: {
        foutboundFreightTaxAmount: "未来Outbound运费税额",
        foutboundFreightwotax: "未来Outbound运费（不含税）",
        foutboundFreightwtax: "未来Outbound运费（含税）",
        fstorageFeeTaxAmount: "未来仓储管理费税额",
        fstorageFeewotax: "未来仓储管理费（不含税）",
        fstorageFeewtax: "未来仓储管理费（含税）",
        ftransportFeeTaxAmount: "未来国内运费运费税额",
        ftransportFeewotax: "未来国内运费运费（不含税）",
        ftransportFeewtax: "未来国内运费运费（含税）",
        storageFeeTaxAmount: "仓储管理费税额",
        storageFeewotax: "仓储管理费（不含税）",
        storageFeewtax: "仓储管理费（含税）",
        transportFeeTaxAmount: "国内运费税额",
        transportFeewotax: "国内运费（不含税）",
        transportFeewtax: "国内运费（含税）",
        dcTime: "鲜货准备时间",
        spTime: "inbound物流运输时间",
        icTime: "供应商准备时间",
        freightDeliveryType: "运费配送类型",
    }
}

export const en = {
    dc: {
        dcNo: 'DC NO',
        dcName: 'DC Name',
        dcStatus: 'DC Status',
        dcInfo: 'DC master data information',
        inputDcNo: 'Please enter dc number',
        inputDcName: 'Please enter dc name',
        inputStatus: 'Please choose dc status',
    },
    supplier: {
        supplierCode: 'supplier code',
        supplierName: 'supplier name',
        supplierCity: 'supplier city',
        supplierAddress: 'supplier address',
        supplierCountry: 'supplier country',
        supplierProvince: 'supplier province',
        supplierPostCode: 'supplier postCode',
        supplierTelephoneNo: 'supplier telephoneNo',
        supplierEmailAddress: 'supplier emailAddress',
        supplierCodeInput: 'Please enter supplier code',
        supplierNameInput: 'Please enter supplier name',
        supplierCityInput: 'Please enter supplier city',
        supplierSelect: 'Please select suppliers',
        editGroup: 'Edit Group',
        group: 'Group',
        groupCode: 'Group Code',
        groupName: 'Group Name',
        supplier: 'Supplier',
        addGroup: 'Add Group',
        addSupplier: 'Add Supplier',
        pleaseSelectGroup: 'Please select group'
    },
    carriers: {
        carriersCode: 'carriers code',
        carriersName: 'carriers name',
        carriersCity: 'carriers city',
        carriersAddress: 'carriers address',
        carriersCountry: 'carriers country',
        carriersProvince: 'carriers province',
        carriersPostCode: 'carriers postCode',
        carriersTelephoneNo: 'carriers telephoneNo',
        carriersEmailAddress: 'carriers emailAddress',
        carriersCodeInput: 'Please enter carriers code',
        carriersNameInput: 'Please enter carriers name',
        carriersCityInput: 'Please enter carriers city',
        carriersSelect: 'Please select carriers'
    },
    fiveBitCode: {
        title: 'Five Bit Code',
        name: 'Five Bit Code Name'
    },
    common: {
        emailAddress: 'email address',
        status: 'status',
        statusAll: 'all',
        statusAble: 'available',
        statusDisable: 'disable',
        updateBy: 'update by',
        updateDate: 'update date',
        dcInfo: 'DC master data information',
        inputDcNo: 'Please enter dc number',
        inputDcName: 'Please enter dc name',
        inputStatus: 'Please choose dc status'
    },
    pp: {
        pickupPoint: 'Pickup Point',
        pickupPointInfo: 'Pick up point information',
        inputPickupPoint: 'Please enter pickup point',
        inputStatus: 'Please choose status',
        selectPickupPoint: 'Please select the delivery point to delete',
    },
    plant: {
        plantNo: 'Plant No',
        plantName: 'Plant Name',
        supplierNo: 'Supplier No',
        supplierName: 'Supplier Name',
        categoryLevel1Name: 'Category Level1 Name',
        categoryLevel2Name: 'category Level2 Name',
        userManage: 'Manage User Info'
    },
    linePrice: {
        lineType:"线路类型",
        pickupPoint: 'Pickup Point',
        dc: 'DC',
        temperature: 'Temperature',
        transportaionMethod: 'Transportaion Method',
        supplierCode: 'Supplier No',
        unit: 'Unit',
        effectiveBeginDate: 'Effective Begin Date',
        price: 'Price(tax-exclusive)',
        currencyCode: 'Currency',
        to: 'To',
        supplier: 'Supplier',
        confirmDate: 'Confirm Date',
        operation: 'Operation',
        update: 'Line Update',
        history: 'See The History',
        sourcingNo: 'Quotation Confirms No',
        export: 'Export',
        exportName: 'Line Price Data',
        fileDownloadError: "File downLoad error",
        selUpdataData: "Select the data that needs to be changed"
    },
    productFreight: {
        updateDate: "Update Date",
        ensureToDisable: "Ensure to Delete the select product freight？",
        productPrice: "Product Freight (No Tax)",
        sendToMDM: "Send To MDM",
        sureDisable: "Are you sure you want to disable the freight of the selected material?",
    },
    material: {
        pickupPoint: 'Pickup Point',

        foutboundFreightTaxAmount: "Future outbound freight tax",
        foutboundFreightwotax: "Future outbound freight (excluding tax)",
        foutboundFreightwtax: "Future outbound freight (including tax)",
        fstorageFeeTaxAmount: "Future storage management fee and tax",
        fstorageFeewotax: "Future storage management fee (excluding tax)",
        fstorageFeewtax: "Future storage management fee (including tax)",
        ftransportFeeTaxAmount: "Future domestic freight and freight tax",
        ftransportFeewotax: "Future domestic freight (excluding tax)",
        ftransportFeewtax: "Future domestic freight (including tax)",
        storageFeewotax: "Storage management fee (excluding tax)",
        storageFeeTaxAmount: "Tax amount of storage management fee",
        storageFeewtax: "Storage management fee (including tax)",
        transportFeeTaxAmount: "Domestic freight tax",
        transportFeewotax: "Domestic freight (excluding tax)",
        transportFeewtax: "Domestic freight (tax included)",
        dcTime: "Fresh goods preparation time",
        spTime: "Inbound logistics transportation time",
        icTime: "Supplier preparation time",
        freightDeliveryType: 'Freight Delivery Type'
    }
}
